import {
  DatasetDurationManager,
  DatasetSizeManager,
  DownloadResultManager,
} from "@/services/license/base/license-manager-abstractions";
import { EmptyDatasetDurationLimiter } from "@/services/license/license-limiters/dataset-duration-limiters/empty-dataset-duration-limiter";
import { EmptyDatasetSizeLimiter } from "@/services/license/license-limiters/dataset-size-limiters/empty-dataset-size-limiter";
import { BeatMachineDownloadResultLimiter } from "@/services/license/license-limiters/download-result-limiters/beat-machine-download-result-limiter";

export class BeatMachineLicenseManager
  implements DatasetDurationManager, DatasetSizeManager, DownloadResultManager
{
  datasetDurationLimiter = new EmptyDatasetDurationLimiter();
  datasetSizeLimiter = new EmptyDatasetSizeLimiter();
  downloadResultLimiter = new BeatMachineDownloadResultLimiter();
}

const beatMachineLicenseManager = new BeatMachineLicenseManager();
export { beatMachineLicenseManager };
